import { render, staticRenderFns } from "./MemberHoverInfo.vue?vue&type=template&id=b0cd536e"
import script from "./member-hover-info.ts?vue&type=script&lang=ts&external"
export * from "./member-hover-info.ts?vue&type=script&lang=ts&external"
import style0 from "./member-hover-info.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports